module.exports = __webpack_public_path__ + "img/car.eecc4c14.svg";